            <div
              class="d-flex align-items-center  mt-1 mb-2"
              style="  height: 25px; margin-left:2em">
                <p class="mb-0 px-3 "
                style="font-family: 'Rubik';padding-top:1.5px; padding-bottom:1.5px; font-size: 13px;font-weight: 400; color: #abdcbe;background-color: #dbfbec;border-radius: 50rem; color: #5bca90">
                  {{ result?.additionalInfo?.carRental?.category }}
                </p>
            </div>

              <div
                class="d-flex flex-row justify-content-center align-items-center py-2"
                style="background-color: #f6f6f6; border-radius: 6px; margin-left:2em; max-width: 80%">
                  <div class="w-100 h-100 d-flex flex-column justify-content-center align-items-center" style="gap: 5px;">
                    <div class="w-50 h-50 d-flex flex-row align-items-center">
                      <p class="rubik-regular-13pt mb-0" style="font-weight: 500; color:black;padding-left: 4px;" >
                        {{ result?.additionalInfo?.carRental?.paxQuantity ? result?.additionalInfo?.carRental?.paxQuantity : 0 }}
                      </p>
                      <img src="../../../../../assets/icons/search-result/persona.svg" width="22px" height="22px" alt="" />
                    </div>
                    <div class="w-auto h-auto">
                      <p class="rubik-regular-12pt mb-0" style="font-weight: 500; color:black;"> Pax </p>
                    </div>
                  </div>
                  <div class="w-100 h-100 d-flex flex-column justify-content-center align-items-center" style="gap: 5px;border-left: 1px solid #b9b9b9; border-right: 1px solid #b9b9b9">
                    <div class="w-50 h-50 d-flex flex-row align-items-center">
                       <p class="rubik-regular-13pt mb-0" style="font-weight: 500; color:black;padding-left: 4px;" >
                        {{ result?.additionalInfo?.carRental?.bagsQuantity ? result?.additionalInfo?.carRental?.bagsQuantity : 0 }}
                       </p>
                      <img src="../../../../../assets/icons/search-result/carry.svg" width="22px" height="22px" alt="" />
                    </div>
                    <div class="w-auto h-auto">
                      <p class="rubik-regular-12pt mb-0" style="font-weight: 500; color:black;"> Maletas </p>
                    </div>
                  </div>
                  <div class="w-100 h-100 d-flex flex-column justify-content-center align-items-center" style="gap: 5px;">
                    <div class="w-auto h-50 d-flex flex-row align-items-center">
                       <p class="rubik-regular-13pt mb-0" style="font-weight: 500; color:black;padding-left: 4px; " >
                        {{ result?.additionalInfo?.carRental?.doors ? result?.additionalInfo?.carRental?.doors : 0 }}
                       </p>
                      <img src="../../../../../assets/icons/search-result/puerta de auto.svg" width="22px" height="22px" alt="" />
                    </div>
                    <div class="w-auto h-auto">
                      <p class="rubik-regular-12pt mb-0" style="font-weight: 500; color:black;"> Puertas </p>
                    </div>
                  </div>
              </div>



              <div class="mt-3 mb-3 d-flex flex-row justify-content-start" style=" gap: 5px; width: 84.5%;">
                <div class="h-100 d-flex flex-row justify-content-start align-items-center" style="border-right: 1px solid #b9b9b9;width: 100%;margin-left: 3em">
                  <div class="d-flex flex-row justify-content-center align-items-center" style="gap: 4px">
                    <img src="../../../../../assets/icons/search-result/caja automática 02.svg" width="22px" height="22px" alt="" />
                    <div class="d-flex flex-column" >
                      <p class="rubik-regular-12pt mb-0" style="font-weight: 500; color:black;">caja</p>
                      <p class="rubik-regular-12pt mb-0" style="font-weight: 500; color:black;">{{result?.additionalInfo?.carRental?.gearbox === 'Automático' ? 'automática' : 'manual'}}</p>
                    </div>
                  </div>
                </div>

                <div class=" h-100 d-flex flex-row justify-content-center align-items-center" style="width: 100%">
                  <div class="d-flex flex-row justify-content-start align-items-center" style="gap: 4px;margin-left: 4px">
                    <img src="../../../../../assets/icons/search-result/aire acondicionado 02.svg" width="22px" height="22px" alt="" />
                     <div class="d-flex flex-column" >
                      <p class="rubik-regular-12pt mb-0" style="font-weight: 500; color:black;">{{result?.additionalInfo?.carRental?.fuel_aircondition === 'Con Aire Acondicionado' ? 'aire' : 'sin aire'}}</p>
                      <p class="rubik-regular-12pt mb-0" style="font-weight: 500; color:black;">acondicionado</p>
                    </div>
                  </div>
                </div>
              </div>
